import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { QuotationFormValues } from "../../../types";
import { QuotationFieldConfig } from "../types";
import { renderQuotationFields } from "./QuotationField";
import { useStyles } from "./styles";

type Props = {
  titleKey: string;
  fields: QuotationFieldConfig[];
  formValues: QuotationFormValues;
  columns?: 3 | 4;
  hideTopBorder?: boolean;
};

const QuotationSection = ({
  titleKey,
  fields,
  formValues,
  columns = 4,
  hideTopBorder,
}: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const gridClassName = columns === 3 ? styles.grid3 : styles.grid4;

  return (
    <Box className={styles.section}>
      <Box
        className={
          hideTopBorder ? styles.sectionHeaderPlain : styles.sectionHeader
        }
      >
        <Typography className={styles.sectionTitle}>{t(titleKey)}</Typography>
      </Box>
      <Box className={gridClassName}>
        {renderQuotationFields(fields, formValues)}
      </Box>
    </Box>
  );
};

export default QuotationSection;
